import { cn } from "@/lib/utils";

const companies = [
  "Vercel",
  "Supabase",
  "Railway",
  "Fly.io",
  "Render",
  "Netlify",
];

interface SocialProofProps {
  className?: string;
}

export function SocialProof({ className }: SocialProofProps) {
  return (
    <section
      className={cn(
        "py-12 px-4 sm:px-6 lg:px-8 bg-white border-y border-slate-100",
        className
      )}
    >
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-sm text-slate-500 mb-8">
          Trusted by developers at
        </p>

        {/* Logo cloud */}
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
          {companies.map((company) => (
            <span
              key={company}
              className="text-xl font-semibold text-slate-300 hover:text-slate-400 transition-colors cursor-default"
            >
              {company}
            </span>
          ))}
        </div>

        {/* Optional: Stats row */}
        <div className="mt-12 pt-8 border-t border-slate-100">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <p className="text-3xl font-bold text-slate-800">10K+</p>
              <p className="text-sm text-slate-500">Developers</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-slate-800">50M+</p>
              <p className="text-sm text-slate-500">API calls/month</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-slate-800">99.99%</p>
              <p className="text-sm text-slate-500">Uptime</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-slate-800">45ms</p>
              <p className="text-sm text-slate-500">Avg response</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialProof;
